import { render, staticRenderFns } from "./company-oems-card.vue?vue&type=template&id=e8a31a8a&scoped=true&"
import script from "./company-oems-card.vue?vue&type=script&lang=js&"
export * from "./company-oems-card.vue?vue&type=script&lang=js&"
import style0 from "./company-oems-card.vue?vue&type=style&index=0&id=e8a31a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a31a8a",
  null
  
)

export default component.exports